import { t } from 'i18next';
import React, { useCallback, useMemo } from 'react';

import { SContentCard } from 'Components/structural/SContentCard/SContentCard';
import { redirect } from 'Libs/routing';
import { getTranslatedLabel } from 'Services/language/languageService';
import { ContentListItem } from 'Store/entities/content/common/types';

import styles from './ContentList.style';
import { formatTranslationStatuses } from './utils';

export type ContentItemProps = {
  content: ContentListItem;
  handleAction: (type: string, contentId: number) => void;
};

export const ContentItem: React.FC<ContentItemProps> = ({ content, handleAction }) => {
  const contentUrl = useMemo(() => `/content/${content.id}`, [content.id]);

  const handleContentClick = useCallback(
    (e) => {
      if (e && e.type === 'click') {
        if (e.ctrlKey || e.metaKey || e.button === 1) {
          return;
        }

        e.preventDefault();
        redirect(contentUrl);
      }
    },
    [contentUrl],
  );

  const options = useMemo(
    () => [
      {
        id: 1,
        text: t('contents:duplication.duplicate_label'),
        onClick: () => handleAction('duplicate', content.id),
      },
      {
        id: 2,
        text: content.archived ? t('contents:unarchive.unarchive_label') : t('contents:archive.archive_label'),
        onClick: content.archived
          ? () => handleAction('unarchive', content.id)
          : () => handleAction('archive', content.id),
      },
    ],
    [content.archived, content.id, handleAction],
  );

  return (
    <a
      href={contentUrl}
      style={styles.contentItemWrapper}
      onClick={handleContentClick}
      data-testid="HREF_KNOWLEDGE_CARD"
    >
      <SContentCard
        id={`#${content.customId}`}
        previewable={false}
        selectable={false}
        displayOption={true}
        options={options}
        title={getTranslatedLabel(content.title) || ''}
        type={content.gameType}
        translationStatuses={formatTranslationStatuses(content.statuses, content.id)}
        style={styles.contentItem}
        imageUrl={content.coverUrl}
        canShowOverlay={true}
        archived={content.archived}
      />
    </a>
  );
};
